import React, { useMemo } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { Cross } from 'assets/assetsV1/iconComponents';

import { Avatar } from 'uiToolkitV1/Avatar';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

const TransientProps = ['isWithCloseButton'];

const StyledTag = styled(Box, {
  shouldForwardProp: (prop) => !TransientProps.includes(prop),
})(({ theme, ...props }) => ({
  boxShadow: theme.shadows.xSmall,
  display: 'flex',
  alignItems: 'center',
  height: '24px',
  padding: props.isWithCloseButton ? '0 0 0 8px' : '0 8px',
  borderRadius: '4px',
  backgroundColor: theme.colors.neutral.F2F2F2,
  width: 'fit-content',
}));

export const TagOutlined = ({ children, StartIcon, startAvatarSrc, onRemove = null, onClick }) => {
  let StartComp = null;
  if (StartIcon) {
    StartComp = <StartIcon boxSize="24px" color="icons.g1" />;
  } else if (startAvatarSrc) {
    StartComp = (
      <Flex alignItems="center">
        <Avatar src={startAvatarSrc} size={18} />
      </Flex>
    );
  }

  const labelMargins = useMemo(() => {
    if (!children) {
      return 0;
    }
    if (StartComp) {
      // in case of text only button
      return '0 0 0 4px';
    }
  }, [children, StartComp]);

  return (
    <StyledTag isWithCloseButton={!!onRemove} onClick={onClick} cursor={onClick ? 'pointer' : 'default'}>
      {StartComp}

      <TextBodyMedium color="text.g1" m={labelMargins}>
        {children}
      </TextBodyMedium>
      {onRemove && (
        <Flex
          h="24px"
          w="24px"
          onClick={onRemove}
          alignItems="center"
          justifyContent="center"
          cursor="pointer"
          _hover={{ backgroundColor: 'neutral.EBEFF3' }}
          borderRadius="4px"
        >
          <Cross color="icons.g1" boxSize="12px" />
        </Flex>
      )}
    </StyledTag>
  );
};
